import React from 'react';
import {Box, Text, VStack, HStack, Pressable} from 'native-base';
import {IReceivable} from '../../../../../../interfaces/dtos';
import {BolivarIcon, DollarIcon} from '../../../../../../components/icons';

interface CustomProps {
  onPress: () => void;
  rowType: 'odd' | 'even';
}

type ItemProps = CustomProps & IReceivable;

const ReceivableItem = (props: ItemProps) => {
  const {id, summary, amount, onPress, rowType} = props;

  const handleOnPress = () => {
    onPress();
  };

  const getStripedColor = () => {
    if (rowType === 'odd') {
      return '#F3F9FF';
    }
    return '#FFFFFF';
  };

  return (
    <Pressable onPress={() => handleOnPress()}>
      <HStack
        width="100%"
        backgroundColor={getStripedColor()}
        paddingY={3}
        paddingX={5}>
        <VStack flex={1}>
          <HStack space={5}>
            <VStack justifyContent="center" space="0" flex={1}>
              <Box justifyContent="center" paddingLeft={1}>
                <Text
                  color="#4C4C4C"
                  fontSize={'20'}
                  ellipsizeMode="tail"
                  numberOfLines={1}>
                  {id}
                </Text>
              </Box>
              <Box>
                <Text
                  color="#99A2B4"
                  fontSize={'14'}
                  ellipsizeMode="tail"
                  numberOfLines={1}>
                  {summary}
                </Text>
              </Box>
            </VStack>
            <HStack w="100">
              <VStack justifyContent="center" space="2">
                <Box justifyContent="center">
                  <DollarIcon />
                </Box>
                <Box justifyContent="center">
                  <BolivarIcon />
                </Box>
              </VStack>
              <VStack justifyContent="flex-end" space="2" w={'85'}>
                <Box alignItems={'flex-end'} paddingLeft="2">
                  <Text fontWeight="bold" color="#06355E" fontSize={'14'}>
                    {amount.foreign}
                  </Text>
                </Box>
                <Box alignItems={'flex-end'} paddingLeft="2">
                  <Text fontWeight="bold" color="#06355E" fontSize={'14'}>
                    {amount.local}
                  </Text>
                </Box>
              </VStack>
            </HStack>
          </HStack>
        </VStack>
      </HStack>
    </Pressable>
  );
};

export default ReceivableItem;
